export const encoder = new TextEncoder();
export const decoder = new TextDecoder();
export function bytesToBase64Url(bytes) {
    let binary = "";
    for (const byte of bytes)
        binary += String.fromCharCode(byte);
    return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/u, "");
}
export function base64UrlToBytes(value) {
    const normalized = value.replaceAll("-", "+").replaceAll("_", "/");
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
    const binary = atob(padded);
    return Uint8Array.from(binary, (character) => character.charCodeAt(0));
}
export function canonicalJson(value) {
    if (value === null || typeof value !== "object")
        return JSON.stringify(value);
    if (Array.isArray(value))
        return `[${value.map(canonicalJson).join(",")}]`;
    const record = value;
    return `{${Object.keys(record)
        .sort()
        .map((key) => `${JSON.stringify(key)}:${canonicalJson(record[key])}`)
        .join(",")}}`;
}
export function createId(prefix) {
    return `${prefix}_${crypto.randomUUID()}`;
}
export function uniqueById(items) {
    return [...new Map(items.map((item) => [item.id, item])).values()];
}
export class OperationSet {
    #operations = new Map();
    add(operation) {
        if (this.#operations.has(operation.id))
            return false;
        this.#operations.set(operation.id, operation);
        return true;
    }
    merge(operations) {
        return operations.reduce((count, operation) => count + Number(this.add(operation)), 0);
    }
    values() {
        return [...this.#operations.values()].sort((a, b) => a.id.localeCompare(b.id));
    }
}
